import { EmptyState } from '@app/components/base/EmptyState';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { defineMessage, FormattedMessage } from 'react-intl';

const futureRangeMessage = defineMessage({
  id: 'segments.listScreen.futureRange',
  defaultMessage: 'El rango seleccionado es futuro',
});

const futureRangeHelpMessage = defineMessage({
  id: 'segments.listScreen.futureRange.help',
  defaultMessage: 'Seleccione un rango anterior para ver la emisión.',
});

/**
 * Empty state shown when the user has selected a date range entirely in the future.
 * No segments are fetched in that case; this message explains why there is no content.
 */
export function FutureRangeMessage() {
  return (
    <EmptyState
      icon={ScheduleIcon}
      message={<FormattedMessage {...futureRangeMessage} />}
      help={<FormattedMessage {...futureRangeHelpMessage} />}
    />
  );
}
